<template>
  <div>
    <v-card flat dense class="mb-2 mt-3" v-if="showList">
      <v-row class="text-end px-4">
        <v-spacer v-if="showList"></v-spacer>
        <v-col cols="12" md="3" class="px-0" v-if="showList">
          <v-btn
            color="primary"
            @click="openAddScreenModel()"
            style="float: right"
            dark
          >
            Create Route-screens
          </v-btn>
        </v-col>
        <v-col cols="12" md="2" class="mr-3">
          <v-btn
            color="primary"
            style="float: right"
            @click="showList = false"
            v-if="showList"
            dark
          >
            Route Screens
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-col>
      <v-data-table
        :headers="screenHeaders"
        :items="allCategoryScreens"
        :loading="screenloader"
        :options.sync="options"
        class="elevation-1 mt-2"
        item-key="id"
        disable-pagination
        hide-default-footer
        v-if="!showList"
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-icon
            class="mr-2"
            @click="editItem(item)"
            v-if="checkPermission('app_accounts:screens_edit')"
          >
            mdi-pencil
          </v-icon>
        </template>
        <template v-slot:top>
          <v-alert
            v-if="successMessage"
            dismissible
            color="success"
            text
            type="success"
            >{{ successMessage }}</v-alert
          >
          <v-alert
            v-if="errorMessage"
            dismissible
            color="red"
            text
            type="error"
            >{{ errorMessage }}</v-alert
          >
          <v-toolbar flat>
            <v-toolbar-title>User Screen</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="openAddScreenModel()"
              style="float: right"
              dark
            >
              Create Route-screens
            </v-btn>
            <v-btn
              color="primary"
              style="float: left"
              @click="showList = false"
              v-if="showList"
              dark
            >
              Route Screens
            </v-btn>
            <v-btn
              color="primary"
              @click="switchToUserScreen()"
              v-if="!showList"
              dark
              style="float: right"
              class="ml-3"
            >
              User Category Screens
            </v-btn>
          </v-toolbar>

          <v-divider></v-divider>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-switch
            v-model="item.status"
            @change="statusChange(item)"
          ></v-switch>
        </template>
      </v-data-table>

      <v-data-table
        v-model="selectedScreens"
        :headers="headers"
        :items="allUserCategoryScreen"
        :loading="loader"
        :options.sync="options"
        :server-items-length="total"
        :search="search"
        class="elevation-1 mt-2"
        item-key="id"
        show-select
        disable-pagination
        hide-default-footer
        v-if="showList"
      >
        <template v-slot:top>
          <v-alert
            v-if="successMessage"
            dismissible
            color="success"
            text
            type="success"
            >{{ successMessage }}</v-alert
          >
          <v-alert
            v-if="errorMessage"
            dismissible
            color="red"
            text
            type="error"
            >{{ errorMessage }}</v-alert
          >
          <v-toolbar flat>
            <v-toolbar-title>Screen</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-row>
              <v-col cols="12" md="12">
                <v-form ref="form" lazy-validation>
                  <v-card-text class="card-padding">
                    <v-row>
                      <v-col cols="12" md="9">
                        <v-select
                          v-model="user_category"
                          label="User Category"
                          class="required"
                          item-text="value"
                          item-value="id"
                          :items="userTypes"
                          @change="fetchUserCategoryScreen()"
                          :rules="[
                            (v) =>
                              (v !== '' && v !== null) ||
                              'User Category is required.',
                          ]"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="3" class="pr-0">
                        <v-btn
                          color="primary"
                          @click="saveUserCategoryScreens()"
                          :loading="saveLoader"
                          dark
                        >
                          save
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
              </v-col>
            </v-row>
          </v-toolbar>
          <v-divider class="my-5"></v-divider>
        </template>
      </v-data-table>
      <template>
        <v-dialog v-model="addDialog" max-width="500px">
          <v-card>
            <v-toolbar flat>
              <v-toolbar-title>
                {{ editedIndex == 0 ? "Add a new" : "Edit" }} screen<i
                  class="caption red--text ml-4"
                >
                  * required field</i
                >
              </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col cols="6" md="6">
                    <v-text-field
                      v-model="name"
                      label="Name"
                      :rules="[(v) => (v && !!v.trim()) || 'Name is required.']"
                      class="required"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6">
                    <v-text-field
                      v-model="path"
                      label="Path"
                      class="required"
                      :rules="[(v) => (v && !!v.trim()) || 'Path is required.']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6">
                    <v-text-field
                      v-model="screen_id"
                      label="Screen Id"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6">
                    <v-text-field
                      v-model="permission_key"
                      label="Permission Key"
                      :rules="[
                        (v) =>
                          (v && !!v.trim()) || 'Permission Key is required.',
                      ]"
                      class="required"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="6" md="6">
                    <v-autocomplete
                      v-model="is_menu"
                      :items="statusArr"
                      dense
                      label="Is menu"
                      :rules="[
                        (v) => (v && !!v.trim()) || 'menu  is required.',
                      ]"
                      class="required mt-5"
                    ></v-autocomplete>
                  </v-col> -->
                  <!-- <v-col cols="6" md="6" v-if="is_menu == 1">
                    <v-text-field
                      v-model="display_name"
                      label="Name"
                      :rules="[(v) => (v && !!v.trim()) || 'Name is required.']"
                      class="required"
                    ></v-text-field>
                  </v-col> -->
                  <!-- <v-col cols="6" md="6" v-if="is_menu == 1">
                    <v-text-field
                      v-model="frontend_route"
                      label="Frontend Route"
                      class="required"
                      :rules="[
                        (v) => (v && !!v.trim()) || 'route is required.',
                      ]"
                    ></v-text-field>
                  </v-col> -->
                  <!-- <v-col cols="6" md="6" v-if="is_menu == 1">
                    <v-text-field
                      v-model="icon"
                      label="Icon"
                      class="required"
                      :rules="[(v) => (v && !!v.trim()) || 'icon is required.']"
                    ></v-text-field>
                  </v-col> -->

                  <!-- <v-col cols="6" md="6" v-if="is_menu == 1">
                    <v-autocomplete
                      v-model="parent_id"
                      :items="parentsArr"
                      dense
                      item-text="name"
                      item-value="id"
                      label="Parent"
                      :rules="[
                        (v) => (v && !!v.trim()) || 'Parent  is required.',
                      ]"
                      class="required mt-5"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" md="6" v-if="is_menu == 1">
                    <v-text-field
                      v-model="sequence"
                      label="Sequence"
                      :rules="[
                        (v) => (v && !!v.trim()) || 'Sequence Key is required.',
                      ]"
                      class="required"
                    ></v-text-field>
                  </v-col> -->
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="editedIndex == 0"
                color="primary"
                @click="saveScreen"
                :loading="saveloader"
                >Save</v-btn
              >
              <v-btn
                v-else
                color="primary"
                @click="updateScreen"
                :loading="saveloader"
                >Update</v-btn
              >
              <v-btn color=" darken-1" class="error" @click="closeDialog"
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userTypes"]),
  },
  data() {
    return {
      headers: [
        {
          text: "Id",
          value: "id",
          class: "body-1 font-weight-bold",
        },
        {
          text: "Screens",
          value: "name",
          class: "body-1 font-weight-bold",
        },
        {
          text: "Screen ID",
          value: "screen_id",
          class: "body-1 font-weight-bold",
        },
      ],
      screenHeaders: [
        {
          text: "Id",
          value: "id",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Name",
          value: "name",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Path",
          value: "path",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Permission key",
          value: "permission_key",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Screen ID",
          value: "screen_id",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
      timerId: null,
      total: 0,
      totalScreen: 0,
      options: {},
      allUserCategoryScreen: [],
      loader: false,
      search: null,
      saveLoader: false,
      user_category: 1,
      userData: {
        name: null,
        email: null,
        status: "active",
        groups: [],
      },
      selectedScreens: [],
      errorMessage: "",
      successMessage: "",
      addDialog: false,
      name: "",
      path: "",
      screen_id: "",
      permission_key: "",
      saveloader: false,
      showList: false,
      allCategoryScreens: [],
      screenloader: false,
      editedIndex: 0,
      is_menu: "",
      statusArr: [
        { text: "Yes", value: "1" },
        { text: "No", value: "0" },
      ],
      parentsArr: [],
      display_name: "",
      frontend_route: "",
      icon: "",
      sequence: "",
      parent_id: "",
    };
  },
  watch: {},

  created() {
    this.getUserTypes();
    this.fetchScreens();
    // this.fetchParents();
  },

  methods: {
    ...mapActions([
      "getUserCategoryScreen",
      "saveUserCategoryScreenList",
      "getUserTypes",
      "saveUserCategoryScreen",
      "addScreen",
      "snackBar",
      "getScreensList",
      "screenStatusChange",
      "updateScreenApi",
      "parentsList",
    ]),
    fetchParents() {
      this.parentsList().then((res) => {
        this.parentsArr = res.data;
      });
    },
    editItem(item) {
      this.editedIndex = item.id;
      this.addDialog = true;
      this.name = item.name;
      this.path = item.path;
      this.screen_id = item.screen_id;
      this.permission_key = item.permission_key;
    },
    fetchScreens() {
      this.screenloader = true;
      this.getScreensList()
        .then((res) => {
          this.allCategoryScreens = res.data;
          this.screenloader = false;
        })
        .catch(() => {
          this.screenloader = false;
        });
    },
    switchToUserScreen() {
      this.showList = true;
      this.fetchUserCategoryScreen();
    },
    fetchUserCategoryScreen() {
      this.loader = true;
      this.getUserCategoryScreen(this.user_category)
        .then((res) => {
          let list = Object.values(res.data.records.screen_applicable);
          this.allUserCategoryScreen = list;
          this.total = res.data.total;
          this.selectedScreens = this.allUserCategoryScreen.filter((e) => {
            if (e.status == true) {
              return e.id;
            }
          });
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    saveUserCategoryScreens() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.selectedScreens.length == 0) {
        this.errorMessage = "Please select at least one screen";
      } else {
        let arr = this.selectedScreens.map((i) => {
          return i.id;
        });
        this.saveLoader = true;
        const payload = {
          user_category: this.user_category,
          user_category_screen: arr,
        };
        this.saveUserCategoryScreen(payload)
          .then(() => {
            this.saveLoader = false;
            this.dialog = false;
            this.successMessage = "Record updated successfully";
            this.fetchUserCategoryScreen();
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
    closeDialog() {
      this.addDialog = false;
      this.name = "";
      this.description = "";
      this.permission_key = "";
      this.screen_id = "";
      this.path = "";
      this.editedIndex = 0;
    },
    openAddScreenModel() {
      this.addDialog = true;
    },

    updateScreen() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveloader = true;
      let payload = {
        name: this.name,
        path: this.path,
        screen_id: this.screen_id,
        permission_key: this.permission_key,

        id: this.editedIndex,
      };
      this.updateScreenApi(payload)
        .then(() => {
          this.saveloader = false;
          this.closeDialog();
          this.snackBar({
            color: "success",
            message: "Screen updated successfully",
          });
          this.showList = false;
          this.fetchScreens();
        })
        .catch(() => {
          this.saveloader = false;
        });
    },
    saveScreen() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveloader = true;
      let payload = {
        name: this.name,
        path: this.path,
        screen_id: this.screen_id,
        permission_key: this.permission_key,
        display_name: this.display_name,
        frontend_route: this.frontend_route,
        icon: this.icon,
        sequence: this.sequence,
        parent_id: this.parent_id,
      };
      this.addScreen(payload)
        .then(() => {
          this.saveloader = false;
          this.closeDialog();
          this.snackBar({
            color: "success",
            message: "Screen Added successfully",
          });
          this.showList = false;
          this.fetchScreens();
        })
        .catch(() => {
          this.saveloader = false;
        });
    },
    async statusChange(item) {
      let payload = {
        id: item.id,
        status: "",
      };
      if (item.status == true) {
        payload.status = 1;
      } else {
        payload.status = 0;
      }
      await this.screenStatusChange(payload)
        .then(() => {
          this.snackBar({
            color: "success",
            message: "Status Updated successfully",
          });
        })
        .catch(() => {
          item.status == true ? false : true;
        });
      this.fetchScreens();
    },
  },
};
</script>

<style scoped>
.card-padding {
  padding-top: 60px;
  margin-left: 14%;
}
</style>
